import { useEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

const useGetCSSVariables = (variablesToGet = []) => {
  const [cssVariableValues, setCssVariableValues] = useState({});
  const { width: screenWidth } = useWindowSize();
  const variablesToGetString = JSON.stringify(variablesToGet);

  useEffect(() => {
    setCssVariableValues(
      variablesToGet.reduce(
        (acc, variableToGet) => ({
          ...acc,
          [variableToGet]: getComputedStyle(
            document.documentElement
          ).getPropertyValue(variableToGet),
        }),
        {}
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth, variablesToGetString]);

  return cssVariableValues;
};

export default useGetCSSVariables;
